let modalDependencyPromise = null;

function modalDependencyUrls() {
  const assets = window.FitCheck?.assets || {};
  return [assets.media_gallery, assets.selling_plan_picker]
    .filter((url) => typeof url === 'string' && url.trim())
    .map((url) => (url.startsWith('//') ? `${window.location.protocol}${url}` : url));
}

export function loadQuickAddModalDependencies() {
  if (modalDependencyPromise) return modalDependencyPromise;

  const urls = modalDependencyUrls();
  if (!urls.length) return Promise.resolve();

  modalDependencyPromise = Promise.all(urls.map((url) => import(url)))
    .then(() => undefined)
    .catch((error) => {
      modalDependencyPromise = null;
      throw error;
    });

  return modalDependencyPromise;
}
